module.exports = __webpack_public_path__ + "img/belgium-lung-cancer-female.086cbefc.png";